<template>
    <div id="container" type="vhomeservicessearch">
        <div class="page homeservices-search"  v-ga:request="{pageType:'vhomeservicessearch', state: {}}" v-ga:page="{pageType:'vhomeservicessearch', glb: glb, state: {}}">
            <mvtHeader />
            <div class="static-section">
              <div class="static-gs homeservices-search__container">
                <div class="card-static-link top-categories">
                  <h2 class="f4 text-bold">Top Categories</h2>
                  <ul>
                    <li v-for="category in topCategories">
                      <a :href="getSearchURL(category)" class="card-static-link text-center">
                        <picture class="top-categories__picture">
                          <img loading="lazy" :src="glb.cdnUrl + 'vimages/homeservices/top/' + category.image" />
                        </picture>
                        <div class="top-categories__title text-bold">{{ category.title }}</div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="search">
                  <h1 class="f3 text-bold">Find a service provider</h1>
                  <p>Planning home repairs, renovations or maintenance? Search vetted local providers.</p>
                  <form v-submit="onSubmit" novalidate>
                    <ThumbtackSearch v-model="search" />
                  </form>
                  <div class="homeservices-search__results">
                    <div v-if="isLoading" class="homeservices-search__loader">
                      <div class="spinner"></div>
                    </div>
                    <ThumbtackResultsList v-if="!isLoading && hasSearched" :query="searchResultTerm" :providers="providers" />
                  </div>
                  <div v-if="!hasSearched" class="static-section popular-searches">
                    <div class="static-gs">
                      <h2 class="f3 text-bold">Popular Searches</h2>
                      <ul>
                        <li v-for="popular in popularSearches">
                          <a :href=" getSearchURL(popular)">
                            <picture class="popular-searches__picture">
                              <img loading="lazy" :src="glb.cdnUrl + 'vimages/homeservices/popular/' + popular.image" />
                            </picture>
                            <div class="popular-searches__title f5 text-bold">{{ popular.title }}</div>
                            <div class="popular-searches__subtitle"><i class="icon-map-pin-home"></i> See pros near you</div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="maintenance-alerts inline welcome">
                  <div class="maintenance-alerts__left">
                    <div>
                      <h3 class="f3 text-bold">Want up-to-date maintenance alerts?</h3>
                      <p>Get tailored recommendations for your home. Stay up-to-date on maintenance to avoid costly repairs.</p>
                      <form autocomplete="off" action="javascript:void(0)">
                        <mvtInputGeo class="large" ref="addressInput" v-model="geoInfo" :placeholder="glb.isPhone ? 'Home Address' : 'Enter Your Home Address'" :options="{types:['address']}">Get Started</mvtInputGeo>
                      </form>
                    </div>
                  </div>
                  <div class="maintenance-alerts__right">
                    <picture>
                      <source media="(max-width: 639px)" :srcset="glb.cdnUrl + 'vimages/homeservices/phone-lockup.png'">
                      <source media="(min-width: 640px)" :srcset="glb.cdnUrl + 'vimages/homeservices/phone-lockup@2x.png'">
                      <source :src="glb.cdnUrl + 'vimages/homeservices/phone-lockup@2x.png'" />
                      <img loading="lazy" :src="glb.cdnUrl + 'vimages/homeservices/phone-lockup@2x.png'" />
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <mvtFooter />
            <mvtPopSignin />
            <mvtDialogCenter></mvtDialogCenter>
        </div>
    </div>
</template>

<script src="./homeservices-search.js"></script>

<style lang="scss">
@use './homeservices-search.scss' as *;
</style>